export default __webpack_public_path__ + "static/media/Size.4b0919cd.jpg";